import { useEffect } from 'react'
import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import Projects from '@/pages/Projects'
import { useLocation, useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/projects', element: <Projects /> },
  { path: '/portfolio', element: <Projects /> },
]

function ScrollToTop() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (hash) return
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }, [pathname, hash])

  return null
}

function App() {
  const element = useRoutes(routes)

  return (
    <>
      <ScrollToTop />
      {element}
    </>
  )
}

export default App
